import React, { Fragment, useEffect, useRef, useState } from "react";
import { TiLocationArrowOutline } from "react-icons/ti";
import { FaArrowRightLong } from "react-icons/fa6";
import { FaArrowLeftLong } from "react-icons/fa6";
import { IoIosArrowDropupCircle } from "react-icons/io";
import { IoIosArrowDropdownCircle } from "react-icons/io";

import OffersCard from "../../Components/big_card/big_card";
import offerpng from "../../Assets/Images/search_offer.png"
import membershippng from "../../Assets/Images/search_membership.png"

import p_nav_previous from "../../Assets/Images/p_nav_light_previous.png";
import VendorProfileCard from "../../Components/vendorProfileCard/vendorProfileCard";
import vendorNotFound from "../../Assets/Images/icons/NoMerchantFound.png";
import { VendorProductServiceCard } from "../../Components/searchComponents/vendorProductServiceCard";
import VendorCategorieList from "../../Components/vendorcategories/vendorCategorieList";
import VoiceSearchInput from "../../Components/VoiceSearchInput/VoiceSearchInput";
import NodeaxiosInstance from "../../Services/nodeaxios";
import { addRecentLocation, clearSearchHistory, getMyLocations, getSearchFilter, getSearchHistory, getSearchProduct, getSearchService, getSearchVendor, userSelectSearchLocation } from "../../Services/api";
import { FaHome } from "react-icons/fa";
import { MdWork } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import Lottie from "lottie-react";
import getlocation from "../../Assets/lottieFiles/getlocation.json"
import { useNavigate } from "react-router-dom";
import HubProfileCard from "../../Components/vendorProfileCard/hubProfileCard";
import { useSelector } from "react-redux";
import PingleFooter from "../../Components/Footer/pingleFooter";
import p_navbars from '../../Assets/Images/icons/navbar_light.png';
import GuestUserSideBar from "../../Components/SideBar/guestUser_sideBar";

const renderSlashSeparatedName = (name) => {
  if (typeof name !== "string" || !name.includes("/")) {
    return name;
  }

  return name.split("/").map((part, index, parts) => (
    <Fragment key={`${part}-${index}`}>
      {part}
      {index < parts.length - 1 && (
        <>
          /
          <br />
        </>
      )}
    </Fragment>
  ));
};

const SearchStoreProfile = () => {

  const navigate = useNavigate();


  const locationModalRef = useRef(null);
  const locationPermissionRef = useRef(null)
  const state = useSelector((state) => state);
  const [userData, serUserData] = useState(state?.userAuth?.user);
  const [selectedOption, setSelectedOption] = useState('Store');
  const [inputSearchValue, setInputSearchValue] = useState("");
  const [openIndices, setOpenIndices] = useState([1, 2, 3]);
  const [fil_location, set_fil_location] = useState('');
  const [fil_type, set_fil_type] = useState(0);
  const [categorieData, setCategorieData] = useState({
    vendor_type_id: 0, vendor_category_id: null,
    vendor_type_name: "", vendor_category_name: "",
  });
  const [vendorTypes, setVendorTypes] = useState([]);
  const [fil_category, set_fil_category] = useState();
  const [vendorList, setVendorList] = useState([])
  const [pageCount, setPageCount] = useState(1);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const [searchResults, setSearchResults] = useState([])
  const [isSearching, setIsSearching] = useState(false);
  const [searchHistoryList, setSearchHistoryList] = useState([]);

  const [locationAccess, setLocationAccess] = useState(false);
  const [locationData, setLocationData] = useState('')
  const [locationsList, setLocationsList] = useState([]);
  const [nearbyVendorList, setNearByvendorList] = useState([])
  const [showSearch, setShowsearch] = useState(false)
  const [totalPages, setTotalPages] = useState(1);
  const [searchFromName, setSearchFromName] = useState("mainSearch");
  const [hasMore, setHasMore] = useState(true);
  const [showSidebar, setShowSidebar] = useState(false);
  const [locLoading, setLocLoading] = useState(false);

  useEffect(() => {
    serUserData(state?.userAuth?.user);
  }, [state?.userAuth?.user]);

  const currentUser = state?.userAuth?.user || userData;

  useEffect(() => {
    if (currentUser?.user_type === "Guest") {
      window.history.pushState({ page: "search-store" }, "", window.location.href);

      const handlePopState = () => {
        if (showSidebar) {
          setShowSidebar(false);
          window.history.pushState({ page: "search-store" }, "", window.location.href);
          return;
        }

        if (showSearch) {
          setShowsearch(false);
          setSearchFromName("mainSearch");
          window.history.pushState({ page: "search-store" }, "", window.location.href);
          return;
        }

        // Keep guest user on search-store and prevent returning to login screen
        window.history.pushState({ page: "search-store" }, "", window.location.href);
      };

      window.addEventListener("popstate", handlePopState);

      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    }
  }, [currentUser?.user_type, showSidebar, showSearch]);

  useEffect(() => {
    if (currentUser?.user_type == "User") {
      getMyLocations().then((res) => {
        setLocationsList(res.data?.saved_locations)
      });
    }
  }, [currentUser?.user_type]);

  useEffect(() => {

    if (categorieData?.vendor_type_id == -1) {
      set_fil_type(-1);
      set_fil_category('');
      setInputSearchValue('');
      getRecentSearchHistory();
      return;
    }

    // setVendorList([]);
    // setSearchResults([]);

    set_fil_category(categorieData?.vendor_category_id || '');
    set_fil_type(categorieData?.vendor_type_id);

    searchByVendor(categorieData, 1);

  }, [categorieData]);


  useEffect(() => {
    if (!showSearch) {
      nearByVendor()
    }
  }, [fil_location])

  useEffect(() => {
    if (!inputSearchValue?.trim()) {
      setSearchResults([]);
    }
  }, [inputSearchValue]);

  const storedLocation = JSON.parse(localStorage.getItem("GuestLocation"));

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollTop + clientHeight >= scrollHeight - 50 &&
      !isLoadingMore && !isSearching && hasMore) {
      const nextPage = pageCount + 1;

      setPageCount(nextPage);
      if (selectedOption === "Store") {
        searchByVendor(categorieData, nextPage);
      } else if (selectedOption === "Product") {
        searchByProduct(nextPage + 1);
      } else if (selectedOption === "Service") {
        searchByService(nextPage + 1);
      } else {
        getRecentSearchHistory(nextPage + 1);
      }

    }
  };

  const toggleAccordion = (index) => {
    if (openIndices.includes(index)) {
      setOpenIndices(openIndices.filter((i) => i != index));
    } else {
      setOpenIndices([...openIndices, index]);
    }
  };

  const parseLatLng = (latlngString) => {
    const [lat, lng] = latlngString.split(',').map(Number);
    return { lat, lng };
  };

  const calculateDistance = (lat1, lng1, lat2, lng2) => {
    const R = 6371e3;
    const φ1 = lat1 * Math.PI / 180;
    const φ2 = lat2 * Math.PI / 180;
    const Δφ = (lat2 - lat1) * Math.PI / 180;
    const Δλ = (lng2 - lng1) * Math.PI / 180;

    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) *
      Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
  };

  const findMatchingLocations = (currentLoc, locations, threshold) => {
    return locations
      .map(loc => {
        const savedLoc = parseLatLng(loc.latlng);

        const distance = calculateDistance(
          currentLoc.lat, currentLoc.lng,
          savedLoc.lat, savedLoc.lng
        );
        return { ...loc, distance };
      })
      .filter(loc => loc.distance <= threshold)
      .sort((a, b) => a.distance - b.distance);
  };

  const getAddressFromCoords = async (lat, lng) => {
    try {
      const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || process.env.REACT_APP_GOOGLE_MAPS_TEST_API_KEY;

      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`
      );

      const data = await response.json();


      // ✅ Check API status first
      if (data.status != "OK") {
        return null;
      }

      if (!data.results || data.results.length == 0) {
        return null;
      }

      return data.results[0];

    } catch (error) {
      return null;
    }
  };

  const buildCurrentLocation = (latitude, longitude, accuracy, addressData) => {
    const latlngString = `${latitude},${longitude}`;
    const localityName = addressData?.address_components?.find(comp => comp.types.includes("locality"))?.long_name || "Current Location";
    const formattedAddress = addressData?.formatted_address || latlngString;

    return {
      locationPayload: {
        latlng: latlngString,
        select_address: formattedAddress,
        select_locality: localityName
      },
      displayLocation: {
        lat: latitude,
        lng: longitude,
        address: formattedAddress,
        location_type_id: "3",
        type: "current",
        locality: localityName,
        accuracy
      }
    };
  };

  const saveGuestLocation = (locationPayload) => {
    if (userData?.user_type == "Guest" || !storedLocation) {
      localStorage.setItem("GuestLocation", JSON.stringify({ locationData: locationPayload }));
    }
  };

  useEffect(() => {
    if (fil_location?.latlng) {
      const isCoord = typeof fil_location?.select_address === "string" && /^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/.test(fil_location.select_address.trim());
      if (!fil_location?.select_address || isCoord) {
        const [lat, lng] = fil_location.latlng.split(',').map(Number);
        if (!isNaN(lat) && !isNaN(lng)) {
          getAddressFromCoords(lat, lng).then(addressData => {
            if (addressData?.formatted_address) {
              const localityName = addressData?.address_components?.find(comp => comp.types.includes("locality"))?.long_name || "";
              set_fil_location(prev => ({
                ...prev,
                select_address: addressData.formatted_address,
                select_locality: prev?.select_locality || localityName
              }));
              setLocationData(prev => ({
                ...prev,
                address: addressData.formatted_address,
                locality: prev?.locality || localityName
              }));
            }
          });
        }
      }
    }
  }, [fil_location?.latlng, fil_location?.select_address]);

  const isMountedRef = useRef(true);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchLocation = (onSuccess, onError, customLocationsList = locationsList) => {
    const checkstatus = JSON.parse(localStorage.getItem("getlocation") || "{}");
    const modelStatus = String(checkstatus?.model) == "false";

    if (modelStatus) {
      const newLocation = {
        latlng: checkstatus?.location?.location_coordinates,
        select_address: checkstatus?.location?.address,
        select_locality: checkstatus?.location?.locality
      };

      set_fil_location(newLocation);
      localStorage.setItem("GuestLocation", JSON.stringify({ locationData: newLocation }));
      if (onSuccess) onSuccess(newLocation);
      return;
    }

    if (!("geolocation" in navigator)) {
      console.log("Geolocation not supported");
      if (onError) onError();
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        if (!isMountedRef.current) return;

        const { latitude, longitude, accuracy } = position.coords;
        const currentLoc = { lat: latitude, lng: longitude, accuracy };

        try {
          const matches = findMatchingLocations(currentLoc, customLocationsList, 100) || [];

          if (matches.length > 0) {
            const match = matches[0];

            const locationPayload = {
              latlng: match.latlng,
              select_address: match.address,
              select_locality: match.locality
            };

            localStorage.setItem("lastKnownLocation", JSON.stringify({ latlng: match.latlng }));

            if (!storedLocation) {
              localStorage.setItem("GuestLocation", JSON.stringify({ locationData: match }));
            }

            setLocationData({
              address: match.address,
              locality: match.location_type,
              location_type_id: match.location_type_id,
              type: "matched",
              distance: match.distance
            });

            set_fil_location(locationPayload);
            addRecentLocation(locationPayload);
            close_location_model("one");
            if (onSuccess) onSuccess(locationPayload);
            return;
          }

          // ✅ No match → use reverse geocode
          const addressData = await getAddressFromCoords(latitude, longitude);
          if (!isMountedRef.current) return;

          const { locationPayload, displayLocation } = buildCurrentLocation(latitude, longitude, accuracy, addressData);

          localStorage.setItem("lastKnownLocation", JSON.stringify({ latlng: locationPayload.latlng }));

          setLocationData(displayLocation);

          saveGuestLocation(locationPayload);
          set_fil_location(locationPayload);
          if (userData?.user_type == "User") {
            addRecentLocation(locationPayload);
          }
          close_location_model();
          if (onSuccess) onSuccess(locationPayload);
        } catch (error) {
          console.log("Location processing error:", error);

          if (isMountedRef.current) {
            const { locationPayload, displayLocation } = buildCurrentLocation(latitude, longitude, accuracy);

            localStorage.setItem("lastKnownLocation", JSON.stringify({ latlng: locationPayload.latlng }));
            saveGuestLocation(locationPayload);
            setLocationData({
              ...displayLocation,
              reason: "processing_error"
            });
            set_fil_location(locationPayload);
          }
          close_location_model();
          if (onError) onError(error);
        }
      },
      (error) => {
        if (isMountedRef.current) {
          if (error?.code === 1) {
            setLocationPermState("denied");
            openpermissionrequiredModal();
          } else {
            setLocationData({
              ...customLocationsList?.[0],
              type: "fallback",
              reason: "geolocation_error"
            });
          }
          close_location_model();
        }
        if (onError) onError(error);
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };

  useEffect(() => {
    fetchLocation(null, null, locationsList);
  }, [locationsList]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        sessionStorage.removeItem("membership");

        // const filterRes = await NodeaxiosInstance.get("/search-filter", {
        //   headers: {
        //     Authorization: userData?.token,
        //   }
        // });

        const filterRes = await getSearchFilter()

        const updatedVendorTypes = filterRes.data.vendor_type.map((item) => ({
          ...item,
          isSelected: false,
        }));

        setVendorTypes(updatedVendorTypes);

        if (userData?.user_type != "Guest") {
          // console.log('(userData?.user_type:', userData?.user_type);

          // const res = await NodeaxiosInstance.get("/selected-location", {
          //   headers: {
          //     Authorization: userData?.token,
          //   }
          // });

          let res = await userSelectSearchLocation()

          if (res?.data?.selected_location) {
            set_fil_location(res.data.selected_location);
          }

          let checkstatus = localStorage.getItem("getlocation") || "";
          if (checkstatus == "false") {
            setLocationData(res.data.selected_location);
          }
        }


      } catch (error) {
        if (error.response?.status == 403) {
          console.error("Forbidden - token might be invalid or expired");
        }
      }
    };

    fetchData();
  }, [inputSearchValue, fil_type]);

  const getRecentSearchHistory = async (page) => {
    const reqData = {
      user_location: fil_location?.latlng || "",
      search_name: '',
      search_type: fil_type || 0,
      search_category: fil_category || "",
      current_page: page || 1,
    };
    page == 1 ? setIsSearching(true) : setIsLoadingMore(true);

    // const response = await NodeaxiosInstance.get("/search-history", {
    //   params: reqData,
    //   headers: { Authorization: userData?.token },
    // });

    const response = await getSearchHistory(reqData)

    if (response) {

      // const newSearches = res.data.search_results.filter((item) =>
      //   item.search_name.toLowerCase().includes(fil_name.toLowerCase())
      // );
      setSearchHistoryList(response?.data?.search_results);
      setIsLoadingMore(false);
    }
  }

  const open_Model = () => {
    const checkstatus = JSON.parse(localStorage.getItem("getlocation") || "{}");
    if (checkstatus?.model === false || checkstatus?.model === "false") {
      return;
    }
    const saved = localStorage.getItem("lastKnownLocation");
    if (!saved) {
      showModalPopup();
      return;
    }

    const savedCoords = JSON.parse(saved).latlng;
    const [savedLat, savedLng] = savedCoords.split(",").map(Number);

    navigator.geolocation.getCurrentPosition((position) => {
      const { latitude, longitude } = position.coords;
      const distance = calculateDistance(savedLat, savedLng, latitude, longitude);
      if (distance > 100) {
        showModalPopup();
      }
    });
  };

  const openpermissionrequiredModal = () => {
    const modal = locationPermissionRef.current;
    if (!modal) return;

    modal.classList.add("show");
    modal.style.display = "block";
    modal.removeAttribute("aria-hidden");
    modal.setAttribute("aria-modal", "true");
    document.body.classList.add("modal-open");
  };



  const closepermissionrequiredModal = () => {
    if (window.bootstrap?.Modal && locationPermissionRef.current) {
      try {
        const bsModal = window.bootstrap.Modal.getInstance(locationPermissionRef.current);
        bsModal?.hide();
      } catch (err) {
        console.log("Bootstrap modal hide error:", err);
      }
    }

    if (locationPermissionRef.current) {
      const modal = locationPermissionRef.current;
      modal.classList.remove("show");
      modal.style.display = "none";
      modal.setAttribute("aria-hidden", "true");
      modal.removeAttribute("aria-modal");
    }

    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) backdrop.remove();

    document.body.classList.remove("modal-open");
    document.body.style.overflow = "auto";
  };


  const close_location_model = (e) => {
    const modalEl = locationModalRef.current;
    // localStorage.setItem("GuestLocation", JSON.stringify({ locationData: locationData }));
    if (modalEl) {
      setTimeout(() => {
        modalEl.classList.add("closing");
        setTimeout(() => {
          modalEl.classList.remove("closing");
          modalEl.classList.remove("show");
          modalEl.style.display = "none";
        }, 1000);
      }, 3000);
    }
  };


  const showModalPopup = () => {
    const modalEl = locationModalRef.current;

    if (modalEl) {
      modalEl.classList.add("show");
      modalEl.style.display = "block";
    }
  };

  const [locationPermState, setLocationPermState] = useState("prompt");

  useEffect(() => {
    let permissionStatus;

    const checkLocationPermission = async () => {
      const checkstatus = JSON.parse(localStorage.getItem("getlocation") || "{}");
      if (checkstatus?.model === false || checkstatus?.model === "false") {
        return;
      }

      try {
        if (navigator.permissions?.query) {
          permissionStatus = await navigator.permissions.query({ name: "geolocation" });

          setLocationPermState(permissionStatus.state);

          if (permissionStatus.state === "granted") {
            closepermissionrequiredModal();
            setLocationAccess(true);
            fetchLocation();
            open_Model();
          } else if (permissionStatus.state === "denied") {
            openpermissionrequiredModal();
          } else if (permissionStatus.state === "prompt") {
            openpermissionrequiredModal();
          }

          permissionStatus.onchange = () => {
            setLocationPermState(permissionStatus.state);

            if (permissionStatus.state === "granted") {
              closepermissionrequiredModal();
              setLocationAccess(true);
              fetchLocation();
              open_Model();
            } else if (permissionStatus.state === "denied") {
              openpermissionrequiredModal();
            }
          };
        }
      } catch (error) {
        console.log("Permission check error:", error);
      }
    };

    checkLocationPermission();

    const handleVisibilityOrFocus = () => {
      if (document.visibilityState === "visible") {
        checkLocationPermission();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityOrFocus);
    window.addEventListener("focus", handleVisibilityOrFocus);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityOrFocus);
      window.removeEventListener("focus", handleVisibilityOrFocus);
      if (permissionStatus) {
        permissionStatus.onchange = null;
      }
    };
  }, []);

  const handleManualPermissionCheck = () => {
    setLocLoading(true);
    fetchLocation(
      () => {
        setLocLoading(false);
        setLocationPermState("granted");
        setLocationAccess(true);
        closepermissionrequiredModal();
        open_Model();
      },
      (error) => {
        setLocLoading(false);
        if (error?.code === 1) {
          setLocationPermState("denied");
          openpermissionrequiredModal();
        }
      }
    );
  };

  const requestLocation = async () => {
    setLocLoading(true);
    fetchLocation(
      () => {
        setLocLoading(false);
        setLocationPermState("granted");
        setLocationAccess(true);
        closepermissionrequiredModal();
        open_Model();
      },
      (error) => {
        setLocLoading(false);
        if (error?.code === 1) {
          setLocationPermState("denied");
          openpermissionrequiredModal();
        }
      }
    );
  };

  const searchByVendor = async (param, page = 1) => {
    const searchText = inputSearchValue?.trim();

    if (fil_type == -1 && searchText) {
      set_fil_type(0);
    }



    page == 1 ? setIsSearching(true) : setIsLoadingMore(true);

    const reqData = {
      user_location: fil_location?.latlng || "",
      search_name: searchText,
      search_type: param?.vendor_type_id || 0,
      search_category: param?.vendor_category_id || "",
      current_page: page == 0 ? 1 : page,
    };



    try {
      // const response = await NodeaxiosInstance.get("/search", {
      //   params: reqData,
      //   headers: { Authorization: userData?.token },
      // });

      const response = await getSearchVendor(reqData)

      const total_pages = response?.data?.total_pages ?? 0;
      const results = response?.data?.search_results ?? [];

      setTotalPages(total_pages);

      if (total_pages == 0 || results == '') {
        setHasMore(false);

      } else {
        setHasMore(true);
      }
      const currentType = param?.vendor_type_id;
      if (Number(response?.data?.search_type) == Number(currentType) || response?.data?.search_type == 0) {
        if (page == 1) {
          setVendorList(results);
        } else {
          setVendorList(prev => {
            const combined = [...prev, ...results];
            const unique = combined.filter((item, index, self) => index == self.findIndex(t => t.vendor_id == item.vendor_id));
            return unique;
          });
        }
      }
      //  else if (Number(response?.data?.search_type) != Number(param?.vendor_type_id)) {
      //   setVendorList([]);

      // }

    } catch (error) {
      console.error("Search API error:", error);
    } finally {
      setIsSearching(false);
      setIsLoadingMore(false);
    }
  };

  const nearByVendor = async () => {

    let reqData = {
      user_location: fil_location?.latlng || "",
      search_name: '',
      search_type: 0,
      search_category: '',
      current_page: pageCount,
    };

    try {
      // const response = await NodeaxiosInstance.get("/search", {
      //   params: reqData,
      //   headers: { Authorization: userData?.token },
      // });
      const response = await getSearchVendor(reqData)

      const results = response?.data?.search_results || [];
      setNearByvendorList(results);
      return response.data;

    } catch (error) {
      console.error("Search API error:", error);
      setNearByvendorList([]);
    } finally {
      setIsSearching(false);
    }

  };

  const searchByService = async (page) => {
    const searchText = inputSearchValue?.trim();

    page == 1 ? setIsSearching(true) : setIsLoadingMore(true);
    try {

      // console.log('fil_location?.latlng', fil_location?.latlng);

      if (fil_location?.latlng) {
        let params = {
          user_location: fil_location?.latlng || "",
          search_name: searchText,
          page: page,
        };
        // const response = await NodeaxiosInstance.get("search-service", {
        //   params: {
        //     user_location: fil_location?.latlng || "",
        //     search_name: searchText,
        //     page: page,
        //   },
        //   headers: { Authorization: userData?.token },
        // });

        const response = await getSearchService(params);

        const searchresults = response.data.search_results;

        if (!searchresults || searchresults.length == 0 || searchresults == [""]) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }


        const updatedResults = searchresults
          .map(item => {
            const filteredServices = (item.services || []).filter(service => {
              const instore = Number(service?.instore_status || 0);
              const doorstep = Number(service?.doorstep_status || 0);

              return instore == 1 || doorstep == 1;
            });

            return {
              ...item,
              services: filteredServices
            };
          })
          .filter(item => item.services.length > 0);


        if (page == 1) {
          setSearchResults(updatedResults);
        } else {
          setSearchResults(prev => {
            const combined = [...prev, ...updatedResults];

            const uniqueVendors = Array.from(
              new Map(combined.map(item => [item.vendor_id, item])).values()
            );

            return uniqueVendors;
          });
        }

        setIsSearching(false)
        setIsLoadingMore(false)
      }
    } catch (err) {
      setSearchResults([]);
    }
  };

  const searchByProduct = async (page) => {
    const searchText = inputSearchValue?.trim();
    page == 1 ? setIsSearching(true) : setIsLoadingMore(true);
    const reqData = {
      user_location: fil_location?.latlng || "",
      search_name: searchText,
      search_type: "",
      search_category: "",
      page: page == 0 ? 1 : page,
    };


    try {
      // const response = await NodeaxiosInstance.get('search-product', {
      //   params: reqData,
      //   headers: {
      //     Authorization: userData?.token,
      //   },
      // });

      const response = await getSearchProduct(reqData)
      const searchResults = response.data.search_results;
      setTotalPages(page)
      if (!searchResults || searchResults.length == 0) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
      const updatedResults = searchResults
        .map(item => {
          const filteredProduct = (item.products || []).filter(products => {
            const instore = Number(products?.instore_status || 0);
            const doorstep = Number(products?.doorstep_status || 0);
            const dinein = Number(products?.dinein_status || 0);
            return instore == 1 || doorstep == 1 || dinein == 1;
          });

          return {
            ...item,
            products: filteredProduct
          };
        })
        .filter(item => item.products.length > 0);

      if (page == 1) {
        setSearchResults(updatedResults);
      } else {
        setSearchResults(prev => {
          const combined = [...prev, ...updatedResults];

          const uniqueVendors = Array.from(
            new Map(combined.map(item => [item.vendor_id, item])).values()
          );

          return uniqueVendors;
        });
      }

      setIsSearching(false)
      setIsLoadingMore(false)
      return response.data;

    } catch (error) {
      console.error("Search API error:", error);
      setSearchResults([]);
    }
  };

  useEffect(() => {

    if (selectedOption == 'Service') {
      searchByService(1)
    }
    else if (selectedOption == 'Product') {
      searchByProduct(1)
    } else {

      searchByVendor(categorieData, 1);
    }
  }, [inputSearchValue]);

  // useEffect(() => {
  //   setVendorList([]);
  // }, [inputSearchValue]);


  const clearAllSearches = () => {
    clearSearchHistory().then((res) => {
      if (res.data?.status == '1') {
        setSearchHistoryList([]);
      }
    });
  };

  function tab_scroll_x(direction) {
    const scrollContainer = document.querySelector('.scroller-style-x');
    const scrollAmount = 200;

    if (direction === 'left') {
      scrollContainer.scrollLeft -= scrollAmount;
    } else if (direction === 'right') {
      scrollContainer.scrollLeft += scrollAmount;
    }
  }
  const toggleSidebar = () => {
    setShowSidebar(!showSidebar)
  }


  return (
    <>
      <div className="bg-white ">
        <div className="SearchStoreProfile offcanvas-parentType1">
          <div className="">
            {/* search navbar */}
            <div className="d-flex justify-content-between primary-bg align-items-center p-3 ">
              <div className="d-flex justify-content-between align-items-center text-white ms-1 me-2 ">
                {userData?.user_type == "Guest" ?
                  <img src={p_navbars} width={'24px'} height={'16px'} role='button' onClick={() => toggleSidebar()} />
                  :
                  <img src={p_nav_previous} width={"20px"} height={"16px"} alt="Previous Button" role="button"
                    onClick={() => { if (showSearch) { setShowsearch(false); setSearchFromName('mainSearch') } else { navigate('/') } }} />}

                <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
                  Search
                </div>
              </div>

              <div className="location-label col-7 d-flex align-items-center justify-content-center" onClick={() => navigate('/find-location', { state: { fromPage: "selectSearch" } })}>
                <div>
                  <div className="d-flex align-items-center">
                    <TiLocationArrowOutline size={20} className="text-white" />
                    <div className="ff-poppins-bold fs-13  ms-1 text-truncate text-white">
                      {locationData?.locality ? locationData?.locality : fil_location.select_locality ? fil_location.select_locality : fil_location.locality}
                    </div>
                  </div>
                  <div className="ff-poppins-regular fs-10 ms-3 text-white">
                    {
                      (() => {
                        const rawAddr = locationData?.address || fil_location?.select_address || fil_location?.address || "";
                        return rawAddr.length > 30 ? rawAddr.slice(0, 30) + "..." : rawAddr;
                      })()
                    }
                  </div>
                </div>
              </div>
            </div>

            {/* search inputbox */}

            <div className="bg-white">
              <div className="p-3 searchboxHeader">
                <div onClick={() => {
                  setShowsearch(true)
                  searchByVendor(categorieData, 1)
                  if (selectedOption == 'stores') {
                    setSearchFromName('stores')
                  } else {
                    setSearchFromName(selectedOption + 's')
                  }
                }}>
                  <VoiceSearchInput
                    value={inputSearchValue}
                    setInputSearchValue={setInputSearchValue}
                    fromPage={searchFromName}
                  />
                </div>

              </div>


              {!showSearch ? (
                <div className="">
                  <div className="full-scroll-y">
                    <div className="nearby-wrapper">
                      <div className="section-box-1">
                        <div className="section-header" onClick={() => toggleAccordion(1)} >
                          <h4 className="section-header-title">Nearby Offers & Memberships</h4>
                          <div className="recentlySearchedStorebox__divider ms-1 me-1">
                            {" "}
                          </div>
                          <span className="arrow">
                            {openIndices?.includes(1) ? (<IoIosArrowDropupCircle />) : (<IoIosArrowDropdownCircle />)}
                          </span>
                        </div>
                        {openIndices?.includes(1) && (
                          <div className="card-row">
                            <div className="big-card offers" onClick={() => navigate('/offer-search')}>
                              <div>
                                {" "}
                                <OffersCard />
                                <h4 className="section-header-title">Big Savings</h4>
                                <p>Offers</p>
                                <img src={offerpng} className="offersIcons" alt="Offers" />
                              </div>
                            </div>
                            <div className="big-card membership" onClick={() => navigate('/membership-search')}>
                              <div>
                                {" "}
                                <OffersCard />
                                <h4>Pro Benefits</h4>
                                <p>Memberships</p>
                                <img src={membershippng} className="membershipIcons" alt="Membership" />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="section-box-2 ">
                        <div className="section-header" onClick={() => toggleAccordion(2)} >
                          <h4 className="section-header-title">Nearby Available Services & Products</h4>
                          <div className="recentlySearchedStorebox__divider ms-1 me-1">
                            {" "}
                          </div>
                          <span className="arrow">
                            {openIndices?.includes(2) ? (
                              <IoIosArrowDropupCircle />
                            ) : (
                              <IoIosArrowDropdownCircle />
                            )}
                          </span>
                        </div>

                        {openIndices?.includes(2) && (
                          <div className="grid-box">
                            {vendorTypes
                              ?.filter(item => item?.vendor_type_id != 0)
                              .map((item, index) => (
                                <div
                                  key={index}
                                  className="searchServiceCard"
                                  onClick={() =>
                                    navigate("/domain-based-fillter", { state: { item, fil_location } })
                                  }
                                >
                                  <div>
                                    <h4 className="vendor-domain-subtitle">{item?.sub_title}</h4>
                                    <p className="vendor-domain-typeName">{renderSlashSeparatedName(item?.vendor_type_name)}</p>
                                  </div>

                                  <img
                                    src={item?.icon}
                                    className="vendorCateIcon"
                                  />
                                </div>
                              ))}
                          </div>
                        )}
                      </div>

                      <div className="section-box-3">
                        <div className="recentlySearchedStorebox">
                          <div className="recentlySearchedStorebox__header" onClick={() => toggleAccordion(3)} >
                            <span className="recentlySearchedStorebox__heading "> Nearby Stores </span>
                            <span className="recentlySearchedStorebox__divider"></span>
                            <span className="recentlySearchedStorebox__icon ">
                              {openIndices?.includes(3) ? (
                                <IoIosArrowDropupCircle />
                              ) : (
                                <IoIosArrowDropdownCircle />
                              )}
                            </span>
                          </div>
                          {/* <div className="p-2 "> */}
                          {openIndices?.includes(3) && (
                            <div style={{ marginTop: "10px" }}>
                              {[...(nearbyVendorList || [])]
                                .sort((a, b) => (a.distance_value || 0) - (b.distance_value || 0))
                                .map((item) => (
                                  <VendorProfileCard
                                    key={item.vendor_id}
                                    data={item}
                                  />
                                ))}
                            </div>
                          )}

                          {/* </div> */}
                        </div>
                      </div>
                    </div>

                    <PingleFooter />
                  </div>
                </div>
              ) : (
                <div className="bg-white">
                  <div className="searchOptionContainer">
                    <div className="searchOptionsList">
                      {["Store", "Service", "Product"].map((item) => (
                        <div key={item} className={`searchOptions ${selectedOption === item ? "active" : ""}`}
                          onClick={() => {
                            if (item == "Product") {
                              setSearchFromName('Products')
                              searchByProduct(1)
                            } else if (item == "Service") {
                              setSearchFromName('Services')
                              searchByService(1)
                            } else {
                              setSearchFromName('Stores')
                              searchByVendor(null, totalPages)
                            }
                            setSearchResults([])
                            setSelectedOption(item)
                            setPageCount(1);
                          }}>
                          {item}
                        </div>
                      ))}
                    </div>
                  </div>


                  <div className="p-3 bg-white">

                    {selectedOption === "Store" && (

                      <>
                        <div className="mb-4">
                          <VendorCategorieList setCategorieData={setCategorieData} fromPage="vendorSearch" />

                        </div>

                        <div className="arrow-controls mb-3 d-flex justify-content-end ">
                          <FaArrowLeftLong
                            className="primary-text me-2 mt-1 arrow-icon"
                            onClick={() => tab_scroll_x("left")}
                          />
                          <FaArrowRightLong
                            className="primary-text me-2 mt-1 arrow-icon"
                            onClick={() => tab_scroll_x("right")}
                          />
                        </div>


                        {fil_type == -1 &&
                          <div className="recentSearch mb-2">
                            <div className="d-flex justify-content-between">
                              <div>
                                <div className="ff-poppins-semiBold fs-14">Recent</div>
                                <div className="ff-poppins-thin fs-16 secondary-text-2">
                                  searches
                                </div>
                              </div>
                              <button onClick={clearAllSearches}>
                                <div className="ff-poppins-light fs-11">Clear all</div>
                              </button>
                            </div>
                          </div>}

                        {
                          fil_type == -1 ?
                            (

                              <div className="  d-flex flex-column" style={{ marginBottom: "265px" }}>
                                <div className="scroller-style-y flex-grow-1 d-flex flex-column" onScroll={handleScroll}  >
                                  {
                                    searchHistoryList.length > 0 ? (
                                      <div style={{ marginBottom: '300px' }}>
                                        {searchHistoryList.map((item, index) => {
                                          const isVendor = item.type == "VENDOR";
                                          return isVendor ? (
                                            <VendorProfileCard
                                              key={item.vendor_id}
                                              data={item}
                                            />
                                          ) : (
                                            <HubProfileCard
                                              key={item.hub_id}
                                              data={item}
                                            />
                                          );
                                        })}

                                        {isLoadingMore && (
                                          <div className="text-center mt-2 fs-13">
                                            Loading more...
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="list scroller-style-y d-flex justify-content-center align-items-center">
                                        <div className="ff-poppins-light fs-13">No Recent Result</div>
                                      </div>
                                    )}
                                </div>
                              </div>
                            )
                            :
                            <>
                              <div className="  d-flex flex-column" style={{ marginBottom: "265px" }}>
                                <div className="scroller-style-y flex-grow-1 d-flex flex-column" onScroll={handleScroll} >
                                  {isSearching ? (
                                    <div className="flex-grow-1 d-flex justify-content-center align-items-center">
                                      <div className="ff-poppins-medium fs-13">
                                        Searching...
                                      </div>
                                    </div>
                                  ) : vendorList.length > 0 ? (
                                    <div style={{ marginBottom: '300px' }}>
                                      {vendorList.map((item, index) => {
                                        const isVendor = item.type == "VENDOR";

                                        return isVendor ? (
                                          <VendorProfileCard
                                            key={item.vendor_id}
                                            data={item}
                                          />
                                        ) : (
                                          <HubProfileCard
                                            key={item.hub_id}
                                            data={item}
                                          />
                                        );
                                      })}

                                      {isLoadingMore && (
                                        <div className="text-center mt-2 fs-13">
                                          Loading more...
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    <div className="no-vendor-container">
                                      <div className="text-center fs-13 ff-poppins-medium  ">
                                        <img
                                          src={vendorNotFound}
                                          className="vendorNotFound"
                                          alt="not-found"
                                        />
                                        <div className=" mt-2">
                                          Oops! No merchant found.
                                        </div>
                                        {inputSearchValue && <p>for "{inputSearchValue}"</p>}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </>


                        }
                      </>
                    )}


                    {selectedOption === "Service" ? (
                      <div className="  d-flex flex-column" style={{ marginBottom: "265px" }}>
                        <div className="scroller-style-y flex-grow-1 d-flex flex-column" onScroll={handleScroll}>
                          {isSearching ? (
                            <div className="d-flex justify-content-center align-items-center h-100 ff-poppins-medium fs-13">
                              Searching...
                            </div>
                          ) :
                            searchResults?.length > 0 ? (
                              <div style={{ marginBottom: '300px' }}>
                                {searchResults?.map((item) => (
                                  <VendorProductServiceCard
                                    key={item.service_id}
                                    cardType={selectedOption}
                                    data={item}
                                  />
                                ))}
                                {isLoadingMore && (
                                  <div className="text-center mt-2 fs-13">
                                    Loading more...
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div className="no-vendor-container">
                                <div className="text-center">
                                  <img src={vendorNotFound} className="vendorNotFound" />
                                  <div className="ff-poppins-light fs-13 mt-2">
                                    Oops! No service found.
                                  </div>{inputSearchValue &&
                                    <p className="ff-poppins-light fs-13">
                                      for "{inputSearchValue}"
                                    </p>}
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    ) : null}

                    {selectedOption == "Product" ? (
                      <div>
                        <div className="  d-flex flex-column" style={{ marginBottom: "265px" }}>
                          <div className="scroller-style-y flex-grow-1 d-flex flex-column" onScroll={handleScroll}>
                            {
                              isSearching ? (
                                <div className="d-flex justify-content-center align-items-center h-100 ff-poppins-medium fs-13">
                                  Searching...
                                </div>
                              ) :
                                Array.isArray(searchResults) && searchResults?.length > 0 ?
                                  <div style={{ marginBottom: '300px' }}>
                                    {
                                      searchResults.map((item) => (
                                        <VendorProductServiceCard
                                          cardType={selectedOption}
                                          data={item}
                                        />
                                      ))}

                                    {isLoadingMore && (
                                      <div className="text-center mt-2 fs-13">
                                        Loading more...
                                      </div>
                                    )}
                                  </div>
                                  :
                                  <div className="no-vendor-container">
                                    <div className="text-center" >
                                      <img src={vendorNotFound} className="vendorNotFound" />
                                      <div className="ff-poppins-light fs-13 mt-2">
                                        Oops! No product found.
                                      </div>
                                      {inputSearchValue && (
                                        <p className="ff-poppins-light fs-13">
                                          for "{inputSearchValue}"
                                        </p>
                                      )}
                                    </div>
                                  </div>
                            }
                          </div>
                        </div>
                      </div>
                    ) : ""}
                  </div>
                  <PingleFooter />
                </div>
              )}
            </ div>


            <div className="location-modal d-flex justify-content-center align-items-center" tabIndex="-1" ref={locationModalRef} >
              <div className="getLocation">
                <Lottie animationData={getlocation} style={{ width: "250px", height: "200px", margin: "auto" }} />
                {/* { locationMatched == true ? */}
                <div>

                  <div className="text-center d-flex justify-content-center align-items-center">
                    <span className="primary-text fs-24">
                      {locationData?.location_type_id === "1" && <FaHome />}
                      {locationData?.location_type_id === "2" && <MdWork />}
                      {locationData?.location_type_id === "3" && <FaLocationDot />}
                    </span>
                    <p className="m-0 ff-poppins-bold fs-18 mt-2 ms-1">
                      {locationData?.locality}
                    </p>
                  </div>
                  <p className="text-dark text-center p-1 mt-3">
                    <span className="d-flex justify-content-center ff-poppins-regular m-0 fs-13">
                      {locationData?.address}
                    </span>
                  </p>

                </div>
              </div>
            </div>

            {/* <div className="modal fade  d-flex justify-content-center" ref={locationPermissionRef} style={{ backgroundColor: ' rgba(0, 0, 0, 0.5)' }}>
              <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "360px" }}>
                <div className="modal-content  "  >
                  <div className="modal-body text-center">
                    <div>
                      <h6 className="ff-poppins-semiBold fs-16 primary-text text-center">Permission Required</h6>
                    </div>
                    <p className="ff-poppins-regular fs-12 p-0 m-0">
                      Location permission is required. <br></br>
                      Please allow access
                    </p> 
                    <button disabled={locLoading}
                      className="rounded-3 primary-bg ouline-non ff-poppins-medium border-none col-3 mt-3 fs-12 text-light p-1" onClick={requestLocation}   >
                      {locLoading ? "Detecting..." : "Allow"}
                    </button>

                  </div>
                </div>
              </div>
            </div> */}
            <div className="modal fade" tabIndex="-1" ref={locationPermissionRef} aria-hidden="true" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
              <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "360px" }}>
                <div className="modal-content position-relative">
                  <button
                    type="button"
                    className="btn-close position-absolute top-0 end-0 m-3"
                    aria-label="Close"
                    onClick={closepermissionrequiredModal}
                  />
                  <div className="modal-body text-center pt-4">
                    <h6 className="ff-poppins-semiBold fs-16 primary-text text-center">
                      Permission Required
                    </h6>

                    {locationPermState === "denied" ? (
                      <>
                        <p className="ff-poppins-regular fs-12 text-danger mt-2">
                          Location access was blocked. <br />
                          Please enable it manually:
                        </p>
                        <ol className="text-start ff-poppins-regular fs-12 mt-2">
                          <li>Tap the lock icon in your browser address bar</li>
                          <li>Tap <b>Site Settings</b></li>
                          <li>Set <b>Location</b> to <b>Allow</b></li>
                          <li>Refresh the page or tap below</li>
                        </ol>
                        <div className="d-flex justify-content-center gap-2 mt-3">
                          <button
                            disabled={locLoading}
                            className="rounded-3 primary-bg ff-poppins-medium border-0 fs-12 text-light p-2 px-3"
                            onClick={handleManualPermissionCheck}>
                            {locLoading ? "Checking..." : "I've Allowed Access"}
                          </button>
                          <button
                            className="rounded-3 border border-secondary ff-poppins-medium bg-transparent fs-12 text-dark p-2 px-2"
                            onClick={() => window.location.reload()}>
                            Refresh Page
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <p className="ff-poppins-regular fs-12 p-0 m-0">
                          Location permission is required. <br />
                          Please allow access
                        </p>
                        <button
                          disabled={locLoading}
                          className="rounded-3 primary-bg ff-poppins-medium border-0 col-3 mt-3 fs-12 text-light p-1"
                          onClick={requestLocation}>
                          {locLoading ? "Detecting..." : "Allow"}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showSidebar &&

            <GuestUserSideBar isOpen={showSidebar} user={userData} onClose={() => setShowSidebar(false)} fromPage="searchScreen" />

          }
        </div>
      </div >
    </>
  );
};

export default SearchStoreProfile;
